import { useRef, useEffect, CSSProperties } from 'react';
import ReactSelect, {
  OptionTypeBase,
  Props as SelectProps,
} from 'react-select';
import { useField } from '@unform/core';
import * as S from './styles';

interface Props extends SelectProps<OptionTypeBase> {
  label: string;
  name: string;
  containerStyle?: CSSProperties;
}

const Select = ({ label, name, containerStyle, ...rest }: Props) => {
  const selectRef = useRef(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      getValue: (ref: any) => {
        if (rest.isMulti) {
          if (!ref.state.value) {
            return [];
          }
          return ref.state.value.map((option: OptionTypeBase) => option.value);
        }
        if (!ref.state.value) {
          return '';
        }
        if (ref.state.value.length > 0) {
          return ref.state.value[0].value;
        }
        return ref.state.value.value;
      },
      setValue: (ref: any, value: any) => {
        if (rest.isMulti && Array.isArray(value)) {
          const items = ref?.props?.options?.filter((option: any) =>
            value.includes(option.value),
          );
          ref?.select.setValue(items);
        } else {
          const item = ref?.props?.options?.filter(
            (option: any) => option.value === value,
          );
          if (item && item.length > 0) {
            ref?.select?.setValue(item);
          }
        }
      },
      clearValue: ref => {
        // eslint-disable-next-line no-param-reassign
        ref.state.value = '';
      },
    });
  }, [fieldName, registerField, rest.isMulti]);

  return (
    <S.Container style={containerStyle}>
      <label htmlFor={name}>{label}</label>
      <ReactSelect
        defaultValue={defaultValue}
        ref={selectRef}
        classNamePrefix="react-select"
        noOptionsMessage={() => 'Nenhum resultado'}
        placeholder="Selecione uma opção..."
        styles={{
          placeholder: () => {
            return {
              padding: '0',
              fontSize: '1.4rem',
            };
          },
          valueContainer: base => {
            return {
              ...base,
              paddingLeft: '0',
            };
          },
        }}
        {...rest}
      />
      {error && <S.Error>{error}</S.Error>}
    </S.Container>
  );
};

Select.defaultProps = {
  containerStyle: {},
};

export default Select;
